import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import BdmDirectory from "./BdmDirectory";
import CanonicalLevels from "./CanonicalLevels";

// Top-level Administration surface for application-level lookup management. Deliberately separate
// from Profile (which is personal-user-oriented) and from ComCodes (franchise/facility data).
// Sections: the BDM Directory, and the read-only Canonical Levels catalog.
export default function Admin() {
  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Box sx={{ mt: 1, mb: 2 }}>
        <Typography variant="h5" component="h1" fontWeight={600}>
          Admin
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Application administration and lookup management.
        </Typography>
      </Box>
      <BdmDirectory />
      <CanonicalLevels />
    </Box>
  );
}
